/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConstructionSiteDetail } from '../models/ConstructionSiteDetail';
import type { ConstructionSites } from '../models/ConstructionSites';
import type { ConstructionSitesMetrics } from '../models/ConstructionSitesMetrics';
import type { CreateAzureTeamBody } from '../models/CreateAzureTeamBody';
import type { LvItems } from '../models/LvItems';
import type { SyncStatus } from '../models/SyncStatus';
import type { TeamAssignments } from '../models/TeamAssignments';
import type { UpdateConstructionSitePlan } from '../models/UpdateConstructionSitePlan';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConstructionSitesService {
    /**
     * create azure team for a construction site
     * @param tenantId tenant_id
     * @param constructionSiteId construction_site_id
     * @param requestBody
     * @returns any connect to existing team
     * @throws ApiError
     */
    public static createAzureTeam(
        tenantId: string,
        constructionSiteId: string,
        requestBody: CreateAzureTeamBody,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/construction_sites/{construction_site_id}/azure_team/create',
            path: {
                'tenant_id': tenantId,
                'construction_site_id': constructionSiteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `team allready in use`,
                404: `team not found`,
                422: `team is archived`,
            },
        });
    }
    /**
     * add unsynced employees to azure team
     * @param tenantId tenant_id
     * @param constructionSiteId construction_site_id
     * @returns any retry azure team sync
     * @throws ApiError
     */
    public static retryAzureTeamSync(
        tenantId: string,
        constructionSiteId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/construction_sites/{construction_site_id}/azure_team/retry_sync',
            path: {
                'tenant_id': tenantId,
                'construction_site_id': constructionSiteId,
            },
            errors: {
                422: `team is archived`,
            },
        });
    }
    /**
     * list construction sites
     * @param tenantId tenant_id
     * @param includeDeleted include_deleted
     * @returns ConstructionSites successful with deleted construction sites
     * @throws ApiError
     */
    public static getConstructionSites(
        tenantId: string,
        includeDeleted?: boolean,
    ): CancelablePromise<ConstructionSites> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/construction_sites',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'include_deleted': includeDeleted,
            },
        });
    }
    /**
     * sync construction sites
     * @param tenantId tenant_id
     * @returns void
     * @throws ApiError
     */
    public static syncConstructionSites(
        tenantId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/construction_sites/sync',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * get status of construction sites sync
     * @param tenantId tenant_id
     * @returns SyncStatus sync status
     * @throws ApiError
     */
    public static getConstructionSitesSyncStatus(
        tenantId: string,
    ): CancelablePromise<SyncStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/construction_sites/sync_status',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * metrics for all construction sites
     * @param tenantId tenant_id
     * @returns ConstructionSitesMetrics successful
     * @throws ApiError
     */
    public static getConstructionSitesMetrics(
        tenantId: string,
    ): CancelablePromise<ConstructionSitesMetrics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/construction_sites/metrics',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * show construction site
     * @param tenantId tenant_id
     * @param id construction_site_id
     * @param actualMinutesFromDate
     * @param actualMinutesToDate
     * @returns ConstructionSiteDetail successful
     * @throws ApiError
     */
    public static getConstructionSite(
        tenantId: string,
        id: string,
        actualMinutesFromDate?: string,
        actualMinutesToDate?: string,
    ): CancelablePromise<ConstructionSiteDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/construction_sites/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            query: {
                'actual_minutes_from_date': actualMinutesFromDate,
                'actual_minutes_to_date': actualMinutesToDate,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * update construction site plan
     * @param tenantId tenant_id
     * @param id construction_site_id
     * @param requestBody
     * @returns TeamAssignments team_assignments updated
     * @throws ApiError
     */
    public static updateConstructionSitePlan(
        tenantId: string,
        id: string,
        requestBody?: UpdateConstructionSitePlan,
    ): CancelablePromise<TeamAssignments> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/construction_sites/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad request`,
            },
        });
    }
    /**
     * list the LV items of a construction site
     * @param tenantId tenant_id
     * @param constructionSiteId construction_site_id
     * @returns LvItems successful
     * @throws ApiError
     */
    public static getLvItems(
        tenantId: string,
        constructionSiteId: string,
    ): CancelablePromise<LvItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/construction_sites/{construction_site_id}/lv_items',
            path: {
                'tenant_id': tenantId,
                'construction_site_id': constructionSiteId,
            },
        });
    }
    /**
     * sync the LV items of the tenant
     * @param tenantId tenant_id
     * @returns void
     * @throws ApiError
     */
    public static syncLvItems(
        tenantId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/lv_items/sync',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * read the state of the last LV item sync
     * @param tenantId tenant_id
     * @returns SyncStatus successful
     * @throws ApiError
     */
    public static getLvItemsSyncStatus(
        tenantId: string,
    ): CancelablePromise<SyncStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/lv_items/sync_status',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
